import { Modal, ModalContent, ModalHeader, Input } from '@nextui-org/react';
import React from 'react';
import { IconClose } from '@/assets';
import { Buttons } from '@/components';
import useGenerate from './useGenerate';
import { debounce } from 'lodash';

const GenerateModal: React.FC<{
  isOpen: boolean;
  onOpenChange: () => void;
  callback: () => void;
}> = ({ isOpen, onOpenChange, callback }) => {
  const { setName, handleGenerate, loading } = useGenerate();

  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      hideCloseButton
      scrollBehavior="inside"
      placement="center"
    >
      <ModalContent className="w-[400px] rounded-[20px]">
        {(onClose) => (
          <>
            <ModalHeader className="flex items-center justify-between p-6 pb-4">
              <span className="text-[18px] font-medium">Generate API Key</span>
              <div
                onClick={onClose}
                className="flex h-[32px] w-[32px] cursor-pointer items-center justify-center rounded-[8px] bg-gray-100"
              >
                <IconClose />
              </div>
            </ModalHeader>
            <div className="px-6 pb-6">
              <p className="text-[13px] font-medium mb-1">API Key Name <span className="text-red-500">*</span></p>
              <Input 
                classNames={{
                  input: [
                    'dark:placeholder:text-white font-normal text-14 pl-1',
                    'rounded-[100px]',
                  ],
                  innerWrapper: '!bg-gray-50 rounded-[100px]',
                  inputWrapper: '!bg-gray-50 rounded-[100px] shadow-none',
                }} 
                onChange={debounce((e) => setName(e.target.value), 500)}
                placeholder="Enter name" 
              />
              <Buttons isLoading={loading} onClick={() => handleGenerate(() => {callback(); onClose()})} className="mt-6 w-full">Generate now</Buttons>
            </div>
          </>
        )}
      </ModalContent>
    </Modal>
  );
}

export default GenerateModal;